module.exports = __webpack_public_path__ + "img/button_tramites_externos-1.cd15a8b3.png";